import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import Accordion from '../../components/Accordion/Accordion';
import Input from '../../components/Input/Input';
import Quote from '../../components/Quote/Quote';
import { apiCall } from '../../APICalls/APICalls';
import Loader from "../../components/Loader/Loader";
import { AccountInfoSP } from '../PageLayout/PageLayout';
import { useSelector, useDispatch } from 'react-redux';
import {
    expandDownIcon,
    revisionHistoryIcon
} from '../../assets/Icons/Icons';
import {
    selectLoadingStatus,
    selectQuotes,
    selectQuoteFilters,
    setQuoteFilters,
    setPreviousQuoteFilters,
    setActiveQuoteInfo,
    selectCustomers,
    getCurrentRevisionIndex,
    selectActiveQuoteInfo,
    selectActiveQuote,
    getQuotes,
    getAllQuotes,
    userCanSuggest,
    userCanApprove,
    hasPendingFlags,
    selectQuoteSearch,
    setQuoteSearch,
    diffSummary,
    quoteStatusClass,
    setQuoterList,
    selectQuoterList,
    formatCustomerNumber
} from '../../store/quotesAndNotificationsSlice';
import {
    setSidePanelTitle,
    selectCredentials,
    selectSidePanelTitle,
    setSidePanelOptions
} from '../../store/pageLayoutSlice';
import './Quotes.css';
import Tooltip from '../../components/Tooltip/Tooltip';
import Actions from './Actions';
import RevisionMessages from './RevisionMessages';

function getQuoteContent(quoteObj, userInfo, sidePanelTitle, activeQuoteInfo){//
    //const currentRevision = quoteObj.quote[ getCurrentRevisionIndex(quoteObj) ];
    const currentRevision = quoteObj.quote[ 0 ];
    const customerInfo = currentRevision.generalInformation.customerInformation;
    const customer = customerInfo.customer;
    // const quoterObj = quoters.find(q => q.userId === currentRevision.userId);
    // const quoter = quoterObj ? quoterObj.userName : currentRevision.userId;
    const quoter = currentRevision.userName;
    return {
        content: <Quote view='quotes' quote={ quoteObj } userInfo={ userInfo } sidePanelTitle={ sidePanelTitle } activeQuoteInfo={ activeQuoteInfo }/>,
        headContent: <div className="quotes_hc_container">
                        <div className="quotes_hc_flex_one">
                            <div className="quotes_hc_quote_number_container">
                                <p className="quotes_hc_label">
                                    Quote #:
                                </p>
                                <p className="quotes_hc_quote_number">
                                    { quoteObj.quoteNumber }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_oppNumber_container">
                                <p className="quotes_hc_label">
                                    Opportunity #:
                                </p>
                                <p className="quotes_hc_quote_customer">
                                    { currentRevision.generalInformation.generalDetails.opportunityNumber }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_customer_container">
                                <p className="quotes_hc_label">
                                    Customer:
                                </p>
                                <p className="quotes_hc_quote_customer">
                                    { customer }
                                </p>
                            </div>
                        </div>

                        <div className="quotes_hc_flex_two">
                            <div className="quotes_hc_quote_subject_container">
                                <p className="quotes_hc_label">
                                    Subject:
                                </p>
                                <p className="quotes_hc_quote_subject">
                                    { currentRevision.generalInformation.generalDetails.quoteSubject }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_quoter_container">
                                <p className="quotes_hc_label">
                                    Quoter:
                                </p>
                                <p className="quotes_hc_quoter_quoter">
                                    { quoter }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_customer_container">
                                <p className="quotes_hc_label">
                                    Customer #:
                                </p>
                                <p className="quotes_hc_quoter_quoter">
                                    { formatCustomerNumber(customerInfo.customerNumber) }
                                </p>
                            </div>
                        </div>

                        <div className="quotes_hc_flex_three">
                            <div className="quotes_hc_quote_created_container">
                                <p className="quotes_hc_label">
                                    { currentRevision.revisionNumber === '0' ? "Created" : "Revised"}:
                                </p>
                                <p className="quotes_hc_quote_subject">
                                    { currentRevision.timestamp }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_customer_container">
                                <p className="quotes_hc_label">
                                    ASM:
                                </p>
                                <p className="quotes_hc_quoter_quoter">
                                    { currentRevision.generalInformation.generalDetails.asm }
                                </p>
                            </div>
                            <div className="quotes_hc_quote_status_container">
                                <p className="quotes_hc_label">
                                    Status:
                                </p>
                                <p className={ "quotes_hc_quote_status " + quoteStatusClass(currentRevision.status) }>
                                    { currentRevision.status }
                                </p>
                            </div>
                        </div>
                    </div>
    };
}

function Quotes(props){
    const quotesArray = useSelector( selectQuotes );
    const dispatch = useDispatch();
    const activeQuoteInfo = useSelector( selectActiveQuoteInfo );
    const userInfo = useSelector( selectCredentials );
    const sidePanelTitle = useSelector( selectSidePanelTitle );
    const loadingStatus = useSelector( selectLoadingStatus );
    const { quoteNumber, subject, quoter, opportunityNumber: opportunityNumberFilter } = useSelector( selectQuoteSearch );
    const quoterList = useSelector( selectQuoterList );
    const customerInfoLength = useSelector( selectCustomers ).length;
    const quoters = useSelector( selectQuoterList );

    useEffect(() => {
        if( customerInfoLength > 0 ){
            dispatch( getAllQuotes() ).unwrap().then( () => {
                apiCall('quotesAndNotifications/getUsersByRole',{ app: "hdmi", userType: "Quoter", role: "quote"}).then( res => {
                    if( res.data.length > 0 ){
                        dispatch( setQuoterList( res.data ) );
                    }
                }).catch(e => console.log(e));
            });
        }
    }, [dispatch, customerInfoLength]);

    const filteredQuotes = useMemo(() => { //search
        let filtered = quotesArray || [];
        if( subject.trim() !== '' ){
            let _subject = subject.toLowerCase();
            filtered = filtered.filter( note => {
                return ( note.quote[0].generalInformation.generalDetails.quoteSubject.toLowerCase().includes(_subject) );
            });
        }
        if( quoteNumber.trim() !== '' ){
            let _quoteNumber = quoteNumber.toLowerCase();
            filtered = filtered.filter( note => {
                return ( note.quoteNumber.toLowerCase().includes(_quoteNumber) );
            });
        }
        if( quoter.trim() !== '' ){
            let _quoter = quoter.toLowerCase();
            const quoterIds = quoterList.filter( q => q.userName.toLowerCase().includes(_quoter) ).map( quoterObj => quoterObj.userId );
            filtered = filtered.filter( note => {
                return ( quoterIds.includes( note.quote[0].userId ) );
            });
        }
        if( opportunityNumberFilter.trim() !== '' ){
            let _opportunityNumber = opportunityNumberFilter.toLowerCase();
            filtered = filtered.filter( note => {
                const oppNum = note.quote[0].generalInformation.generalDetails.opportunityNumber;
                return ( oppNum && oppNum.toLowerCase().includes(_opportunityNumber) );
            });
        }
        return filtered;
    }, [ quotesArray, quoteNumber, subject, quoterList, quoter, opportunityNumberFilter ]);

    return (
        <div id="quotes_wrapper">
            {
                filteredQuotes.map((quote, i) => {
                    let isOpen = (quote.quoteId === activeQuoteInfo.quoteId);
                    let {
                        content,
                        headContent
                    } = getQuoteContent(quote, userInfo, sidePanelTitle, activeQuoteInfo, quoters);
                    let quoteInfo = {
                        quoteId: quote.quoteId,
                        revisionNumber: quote.quote[ 0 ].revisionNumber,
                        index: i
                    };
                    //console.log(quote);
                    return (
                        <Accordion
                            contentDescription="Quote"
                            headContent={ headContent }
                            isTopAccordion={ false }
                            iconRight={ expandDownIcon }
                            iconRightAnimate={ true }
                            key={ quote.quoteNumber + i }
                            onClick={ () => dispatch( setActiveQuoteInfo( quoteInfo ) ) }
                            controlled={ true }
                            isOpen={ isOpen }
                        >
                            { content }
                        </Accordion>
                    );
                })
            }
            {
                filteredQuotes.length === 0 &&
                <div>
                    <p className="empty_message">There are no quotes that match the filter and/or search values.</p>
                </div>
            }
            { (loadingStatus.quotes === 'loading' ||
               loadingStatus.putSuggestion === 'loading' ||
               loadingStatus.printQuote === 'loading' ||
               loadingStatus.approveQuote === 'loading' ||
               loadingStatus.denyQuote === 'loading' ||
               loadingStatus.approveWithChange === 'loading' ||
               loadingStatus.approveOnBehalf === 'loading') && <Loader /> }
        </div>
    );
}

function QuotesSPC(props){

    const dispatch = useDispatch();

    const activeQuote = useSelector( selectActiveQuote );
    const activeQuoteInfo = useSelector( selectActiveQuoteInfo );
    const sidePanelTitle = useSelector( selectSidePanelTitle );
    const quoteFilters = useSelector( selectQuoteFilters );
    const credentials = useSelector( selectCredentials );
    const quoteSearch = useSelector( selectQuoteSearch );

    const {
        userId,
        userType
    } = credentials;

    const {
        role,
        permissions
    } = userType;

    let canRevise = false;
    let canSuggestModification = false;
    let canApprove = false;
    let canApproveOnBehalf = false;
    let canPrint = false;
    let canExport = false;
    let canViewHistory = false;
    let shouldDefaultHistory =  false;
    //let reasonForDenial;
    let quoteStatus;
    let suggestions = [];
    let modifications = [];
    let flags = [];
    let content;
    let denialReason;
    const sidePanelOptions = [];

    if( activeQuote ){
        //let currentRevisionIndex = getCurrentRevisionIndex(activeQuote);
        let currentRevisionIndex = 0;
        quoteStatus = activeQuote.quote[currentRevisionIndex].status.toLowerCase();
        suggestions = [ ...activeQuote.quote[currentRevisionIndex].suggestions ];
        modifications = [ ...activeQuote.quote[currentRevisionIndex].modifications ];
        //reasonForDenial = activeQuote.quote[currentRevisionIndex].denialReason;
        flags = [ ...activeQuote.quote[currentRevisionIndex].flags ];
        denialReason = activeQuote.quote[currentRevisionIndex].denialReason;

        canRevise = permissions.includes("Create Quote Revision");
        canApproveOnBehalf = permissions.includes("Approve On Behalf") && hasPendingFlags(flags);
        canApprove = permissions.includes("Approve Quote") && userCanApprove( activeQuote.quote[currentRevisionIndex], userId, role );
        canSuggestModification = permissions.includes("Suggest Modifications") && userCanSuggest( activeQuote.quote[currentRevisionIndex], userId );
        canPrint = permissions.includes("Print Quotes") && quoteStatus === 'approved';
        canExport = permissions.includes("Export Quote") && quoteStatus === 'approved';
        canViewHistory = (userType.userType === 'Admin' || userType.userType === 'Quoter');
        shouldDefaultHistory = (!(canPrint || canExport || canApprove || canApproveOnBehalf) && canViewHistory);
    }

    useEffect(() => {
        dispatch( setSidePanelTitle('Search') );
    }, [dispatch]);

    useLayoutEffect(()=>{
        let contentName = 'Search';
        if( activeQuote){  
            if( quoteStatus.toLowerCase() === 'denied' ){
                contentName = 'Messages';
                sidePanelOptions.push('Messages');
                if( canRevise ){
                    sidePanelOptions.push('Actions');
                }
            } else if(canPrint || canExport || canApprove || canApproveOnBehalf || canSuggestModification || canRevise){
                if( canRevise || canSuggestModification ){ //anyone who can revise quote or make suggestions can view messages
                    sidePanelOptions.push('Messages');
                    if( modifications.length > 0 || suggestions.length > 0 ){
                        contentName = 'Messages';
                    } else if( shouldDefaultHistory ){
                        contentName = 'History';
                    } else {
                        contentName = 'Actions';
                    } 
                } else if( shouldDefaultHistory ){
                    contentName = 'History';
                } else {
                    contentName='Actions';
                }
                sidePanelOptions.push('Actions');
            } else if( canViewHistory ) {
                contentName = 'History';
            }
            if( canViewHistory ){
                sidePanelOptions.push('History');
            }
        }
        sidePanelOptions.push('Search');
        sidePanelOptions.push('Account');
        dispatch( setSidePanelTitle(contentName) );
        dispatch( setSidePanelOptions( sidePanelOptions ) );
    }, [ activeQuote, dispatch ]);

    switch( sidePanelTitle ){
        case 'Messages':
            content = <RevisionMessages 
                    activeQuote={ activeQuote }
                    canRevise={ canRevise }
                    suggestions={ suggestions }
                    modifications={ modifications }
                    denialReason={ denialReason }
                    flags={ flags }
                />;
        break;
        case 'Actions':
            content = <Actions
                        userType={ userType }
                        flags={ flags }
                        canSuggest={ canSuggestModification }
                        canApprove={ canApprove }
                        canApproveOnBehalf={ canApproveOnBehalf }
                        canPrint={ canPrint }
                        canExport={ canExport }
                        canRevise={ canRevise }
                        activeQuote={ activeQuote }
                        activeQuoteInfo={ activeQuoteInfo }
                        credentials={ credentials }
                        quoteFilters={ quoteFilters }
                        quoteStatus={ quoteStatus }
                        view="quotes"
                    />;
        break;
        case 'History':
            content = <RevisionHistory
                        activeQuote={ activeQuote }
                        activeQuoteInfo={ activeQuoteInfo }
                    />;
        break;
        case 'Account':
            content = <AccountInfoSP />;
        break;
        case 'Search':
            content = <Filters
                        quoteFilters={ quoteFilters }
                        quoteSearch={ quoteSearch }
                    />;
        break;
        default:
            content = <Filters
                        quoteFilters={ quoteFilters }
                        quoteSearch={ quoteSearch }
                    />;
    }

    return (
        <div>
            { content }
        </div>
    );
}

function Filters(props){

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( setSidePanelTitle('Search') );
    }, [ dispatch ]);

    const quoteFilters = props.quoteFilters;

    const { customer, customerNumber, status, opportunityNumber } = quoteFilters.current;

    const previousCustomer = quoteFilters.previous.customer;

    const previousCustomerNumber = quoteFilters.previous.customerNumber;

    const previousStatus = quoteFilters.previous.status;

    const previousOpportunityNumber = quoteFilters.previous.opportunityNumber

    const { quoteNumber, subject, quoter, opportunityNumber: opportunityNumberFilter } = props.quoteSearch;

    const customerInfo = useSelector( selectCustomers );

    const quotes = useSelector( selectQuotes );

    const quoters = useSelector( selectQuoterList );

    const quoterNames = useMemo( () => {
        return quoters.map( q => q.userName );
    }, [ quoters ]);

    //const { customers, customerNumbers } = useMemo(() => {
        const { customers } = useMemo(() => {
        let customers = [];
        //let customerNumbers = [];
        customerInfo.forEach( customer => {
            customers.push( customer.customer );
            //customerNumbers.push( customer.customerNumber );
        });
        customers = [...new Set(customers)]; //remove duplicates
        return {
            customers: customers
            //customerNumbers: customerNumbers
        };
    }, [ customerInfo ]);

    const customerNumbers = useMemo(() => {
        let filteredNumbers = [];
        let customerIndex = -1;
        if( customer ){
            customerIndex = customerInfo.findIndex( cust => cust.customer === customer );
        }
        if( customerIndex !== -1 ){
            customerInfo.forEach( cust => {
                if( cust.customer === customer ){
                    filteredNumbers.push( formatCustomerNumber(cust.customerNumber) );
                }
            });
        } else {
            customerInfo.forEach( cust => {
                filteredNumbers.push( formatCustomerNumber(cust.customerNumber) );
            });
        }
        return filteredNumbers;
    }, [ customerInfo, customer ]);

    useEffect(() => {
        if( customerNumbers.length === 1 ){
            dispatch( setQuoteFilters({ filter: 'customerNumber', value: '0000'+customerNumbers[0] }) );
        }
    }, [ dispatch, customerNumbers ]);

    const { quoteNumbers, subjects } = useMemo(() => {
        let quoteNums = [];
        let subjectArr = [];
        quotes.forEach( quote => {
            quoteNums.push( quote.quoteNumber );
            subjectArr.push( quote.quote[0].generalInformation.generalDetails.quoteSubject );
        });
        return {
            quoteNumbers: quoteNums,
            subjects: subjectArr
        };
    }, [ quotes ]);

    const opportunityNumbers = useMemo(() => {
        let oppNums = [];
        quotes.forEach( quote => {
            const oppNum = quote.quote[0].generalInformation.generalDetails.opportunityNumber;
            if( oppNum && oppNum.trim() !== '' ){
                oppNums.push( oppNum );
            }
        });
        return [...new Set(oppNums)]; // remove duplicates
    }, [ quotes ]);

    useEffect(() => {
        if( (customer === '' && customerNumber === '' && status === '' && opportunityNumber === '') && (previousCustomer !== customer || previousCustomerNumber !== customerNumber || previousStatus !== status || previousOpportunityNumber !== opportunityNumber) ){
            dispatch( getAllQuotes() );
            dispatch( setPreviousQuoteFilters() );
        }
    }, [ dispatch, customer, customerNumber, status, opportunityNumber, previousCustomer, previousCustomerNumber, previousStatus, previousOpportunityNumber ]);

    function handleFilter(){
        let _status = status.trim() === '' ? '' : status.trim();
        let _customerNumber = customerNumber === undefined || customerNumber.trim() === '' ? '' : customerNumber.trim();
        let _customer = customer.trim();
        let _opportunityNumber = opportunityNumber === undefined || opportunityNumber.trim() === '' ? '' : opportunityNumber.trim();
        if( _status === '' && _customerNumber === '' && _customer === '' && _opportunityNumber === '' ){
            dispatch( getAllQuotes() );
            dispatch( setActiveQuoteInfo({ quoteId: null, revisionNumber: null, index: null}) );
            dispatch( setPreviousQuoteFilters() );
        } else {
            const filterReqObject = {};
            if( _customerNumber !== '' ){
                filterReqObject['customerNumber'] = formatCustomerNumber(_customerNumber);
            }
            if( _status !== '' ){
                filterReqObject['status'] = _status;
            }
            if( _opportunityNumber !== '' ){
                filterReqObject['opportunityNumber'] = _opportunityNumber;
            }
            console.log(filterReqObject);
            //dispatch( getQuotes({ customerNumber: _customerNumber, status: _status }) );
            dispatch( getQuotes(filterReqObject) );
            dispatch( setActiveQuoteInfo({ quoteId: null, revisionNumber: null, index: null}) );
            dispatch( setPreviousQuoteFilters() );
        }
    }

    return (
        <div className="quotes_sp_filters">
            <div className="quotes_sp_input_container">
                <Input 
                    type="searchable"
                    value={ customer }
                    handleChange={ 
                        (e) => dispatch( setQuoteFilters({ filter: 'customer', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteFilters({ filter: 'customer', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteFilters({ filter: 'customer', value: '' }) )
                    }
                    options={ customers }
                    placeHolder="Customer"
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input 
                    type="searchable"
                    value={ formatCustomerNumber(customerNumber) }
                    handleChange={ 
                        (e) => dispatch( setQuoteFilters({ filter: 'customerNumber', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteFilters({ filter: 'customerNumber', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteFilters({ filter: 'customerNumber', value: '' }) )
                    }
                    options={ customerNumbers }
                    placeHolder="Customer Number"
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input
                    type="searchable"
                    value={ status }
                    handleChange={
                        (e) => dispatch( setQuoteFilters({ filter: 'status', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteFilters({ filter: 'status', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteFilters({ filter: 'status', value: '' }) )
                    }
                    options={ ['Pending', 'Approved', 'Approved With Change', 'Denied'] }
                    placeHolder="Quote Status"
                />
            </div>
            <div className="filter_button_container">
                <button
                    className="filter_button"
                    onClick={ handleFilter }
                >
                    Search
                </button>
            </div>
            <div className="filter_title">
                <h3 className="side_panel_title">
                    Filter
                </h3>
                <Tooltip
                    size={14}
                    color="#1965A3"
                    strokeWidth={1.5}
                    fontSize={12}
                    tip="The search fields retrieve quotes from the server while the filter fields filter the quotes in real time."
                    tipStyles={
                        {
                            position: 'absolute',
                            bottom: '6px',
                            left: '67px',
                            backgroundColor: '#ffffff',
                            fontSize: '12px',
                            zIndex: '5',
                            border: '1px solid gray',
                            borderRadius: '3px',
                            padding: '5px',
                            boxShadow: '1px 1px 2px 1px rgba(0, 0, 0, 0.3)',
                            textAlign: 'left'
                        }
                    }
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input 
                    type="searchable"
                    value={ subject }
                    handleChange={ 
                        (e) => dispatch( setQuoteSearch({ field: 'subject', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteSearch({ field: 'subject', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteSearch({ field: 'subject', value: '' }) )
                    }
                    options={ subjects }
                    placeHolder="Quote Subject"
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input 
                    type="searchable"
                    value={ quoteNumber }
                    handleChange={ 
                        (e) => dispatch( setQuoteSearch({ field: 'quoteNumber', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteSearch({ field: 'quoteNumber', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteSearch({ field: 'quoteNumber', value: '' }) )
                    }
                    options={ quoteNumbers }
                    placeHolder="Quote #"
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input
                    type="searchable"
                    value={ quoter }
                    handleChange={
                        (e) => dispatch( setQuoteSearch({ field: 'quoter', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteSearch({ field: 'quoter', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteSearch({ field: 'quoter', value: '' }) )
                    }
                    options={ quoterNames }
                    placeHolder="Quoter"
                />
            </div>
            <div className="quotes_sp_input_container">
                <Input
                    type="searchable"
                    value={ opportunityNumberFilter }
                    handleChange={
                        (e) => dispatch( setQuoteSearch({ field: 'opportunityNumber', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setQuoteSearch({ field: 'opportunityNumber', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setQuoteSearch({ field: 'opportunityNumber', value: '' }) )
                    }
                    options={ opportunityNumbers }
                    placeHolder="Opportunity #"
                />
            </div>

        </div>
    );
}


function RevisionHistory(props){

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( setSidePanelTitle('History') )
    }, [ dispatch ]);

    const {
        activeQuote,
        activeQuoteInfo
    } = props;

    const createRevisionList = useMemo(() => {
        const accordions = [];
        if( activeQuote && activeQuote.quote.length > 1 ){
            for ( let i = 1; i < activeQuote.quote.length; i++ ){
                let diffArray = diffSummary(activeQuote.quote[i], activeQuote.quote[i - 1], 'history');
                let date = new Date(activeQuote.quote[i - 1].timestamp);
                let isOpen = (activeQuote.quoteId === activeQuoteInfo.quoteId && activeQuote.quote[i].revisionNumber === activeQuoteInfo.revisionNumber);
                accordions.push(
                    <Accordion
                        key={i}
                        contentDescription="Revision History"
                        headContent={ 
                            <div className="action_button_accordion_header">
                                { revisionHistoryIcon }
                                <span className="quote_action_button_text revision_history_button">
                                    { stringifyDate(date) }
                                </span>
                            </div>
                        }
                        isTopAccordion={ false }
                        contentClass="side_panel_accordion_content"
                        onClick={ () => dispatch( setActiveQuoteInfo( { quoteId: activeQuote.quoteId, revisionNumber: activeQuote.quote[i].revisionNumber, caller: 'history' } ) ) }
                        controlled={ true }
                        isOpen={ isOpen }
                    >
                        <div className="revision_history_container">
                            <ul className="diff_summary_list">
                                {
                                    diffArray.map( (difference, i) =>{
                                        return (
                                            <li className="diff_summary_li" key={i}>{difference}</li>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                    </Accordion>
                );
            }
        }
        return accordions;
    }, [ activeQuote, activeQuoteInfo, dispatch ]);
    
    return (
        <div className="quotes_sp_revisionHistory">
            { 
                createRevisionList.length > 0 ?            
                createRevisionList
                :
                <div>
                    <p style={{textAlign: 'left'}}>There is currently only one version of this quote.</p>
                </div>
            }
        </div>
    );
}

function stringifyDate(dateObj){
    let day = dateObj.getDate().toString();
    let year = dateObj.getFullYear().toString();
    let monthNumber = dateObj.getMonth();
    let month;
    day = day.length < 2 ? ('0' + day) : day;

    switch( monthNumber ){
        case 0:
            month = 'January';
        break;
        case 1:
            month = 'February';
        break;
        case 2:
            month = 'March';
        break;
        case 3:
            month = 'April';
        break;
        case 4:
            month = 'May';
        break;
        case 5:
            month = 'June';
        break;
        case 6:
            month = 'July';
        break;
        case 7:
            month = 'August';
        break;
        case 8:
            month = 'September';
        break;
        case 9:
            month = 'October';
        break;
        case 10:
            month = 'November';
        break;
        case 11:
            month = 'December';
        break;
        //no default
    }
    return month + ' ' + day + ', ' + year;
}

export default Quotes;
export { QuotesSPC };